import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';

import { TABLE_UNMOUNT } from '../Table/tableActions';
import { getEntityByName } from '../appEntities';
import {
    PAYOUT_BATCHES_FAILURE,
    PAYOUT_BATCHES_LOAD,
    PAYOUT_BATCHES_SUCCESS,
    PENDING_PAYOUT_BATCHES_SUCCESS,
    PENDING_COUNT_FAILURE,
    PENDING_COUNT_LOAD,
    PENDING_COUNT_SUCCESS
} from './payoutBatchesActions';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                payoutBatches: []
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_BATCHES_LOAD:
            newState = {
                ...state,
                payoutBatches: [],
                error: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_BATCHES_SUCCESS:
            newState = {
                ...state,
                payoutBatches: action.payoutBatches,
                count: action.count,
                loading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case PENDING_PAYOUT_BATCHES_SUCCESS:
            newState = {
                ...state,
                payoutBatches: action.payoutBatches,
                pendingCount: action.count,
                loading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_BATCHES_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;

        case PENDING_COUNT_LOAD:
            newState = {
                ...state,
                countError: null,
                countLoading: true,
                pendingCount: 0
            };

            return isEqual(state, newState) ? state : newState;

        case PENDING_COUNT_SUCCESS:
            newState = {
                ...state,
                countLoading: false,
                pendingCount: action.count
            };

            return isEqual(state, newState) ? state : newState;

        case PENDING_COUNT_FAILURE:
            newState = {
                ...state,
                countError: action.error,
                countLoading: false
            };

            return isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getPayoutBatchesEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'payoutBatches')
);

export const getPages = createSelector(
    getPayoutBatchesEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getPayoutBatchesEntity,
    (entity) => get(entity, 'count')
);

export const getIsPayoutBatchesLoading = createSelector(
    getPayoutBatchesEntity,
    (entity) => get(entity, 'loading')
);

export const getPayoutBatches = createSelector(
    getPayoutBatchesEntity,
    (entity) => get(entity, 'payoutBatches')
);

export const getPayoutBatchesError = createSelector(
    getPayoutBatchesEntity,
    (entity) => get(entity, 'error')
);

export const getPayoutBatchesErrorMessage = createSelector(
    getPayoutBatchesError,
    (error) => get(error, 'message')
);

export const getHasMore = createSelector(
    getPayoutBatchesEntity,
    (entity) => get(entity, 'hasMore')
);

export const getPendingCount = createSelector(
    getPayoutBatchesEntity,
    (entity) => get(entity, 'pendingCount')
);

export const getIsPendingCountLoading = createSelector(
    getPayoutBatchesEntity,
    (entity) => get(entity, 'countLoading')
);

export const getPendingCountError = createSelector(
    getPayoutBatchesEntity,
    (entity) => get(entity, 'countError')
);

export const getPendingCountErrorMessage = createSelector(
    getPendingCountError,
    (error) => get(error, 'message')
);
